/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('settings', ['CollectionService', '$timeout', function(CollectionService, $timeout){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/settings/settings.html',
            scope: {
                parent: '=',
                active: '='
            },
            link: function(scope, element, attrs) {

                scope.collection = {description: "", isDropboxEnabled: false, isAssignmentToolEnabled: false};

                scope.settingsChanged = false;

                scope.$watch('parent', function() {
                    if(scope.parent){
                        if(scope.parent.description) {
                            scope.collection.description = scope.parent.description.length > 255 ? scope.parent.description.substring(0, 255) : scope.parent.description;
                        }
                        scope.collection.isDropboxEnabled = scope.parent.isDropboxEnabled;
                        scope.collection.isAssignmentToolEnabled = scope.parent.isAssignmentToolEnabled;
                        scope.setSettingsChanged();
                    }
                });

                scope.$watch('active', function(){
                    if(scope.active && scope.active === 'settings'){
                        if(scope.settingsApplied){
                            scope.settingsApplied = false;
                        }
                        $timeout(function(){
                            var settingsFolderDescriptionElement = angular.element('#settingsDescriptionTextarea');
                            settingsFolderDescriptionElement.focus();
                        });
                    }
                });

                scope.$watch('collection.description', function(){
                    if(scope.parent && scope.collection.description !== scope.parent.description.substring(0, 255)){
                        scope.settingsApplied = false;
                        scope.settingsChanged = true;
                    }
                });

                scope.maxDescriptionLength = 255;

                scope.toggleDropbox = function() {
                    var toggleDropBox = new CollectionService.ToggleDropBox({cid: scope.parent.cid, enable: scope.collection.isDropboxEnabled});
                    toggleDropBox.$save(function(response){
                        if(response.result) {
                            scope.parent.isDropboxEnabled = scope.collection.isDropboxEnabled;
                        }
                    });
                };

                scope.toggleAssignmentTool = function() {
                    var toggleAssignmentTool = new CollectionService.ToggleAssignmentTool({cid: scope.parent.cid, enable: scope.collection.isAssignmentToolEnabled});
                    toggleAssignmentTool.$save(function(response){
                        if(response.result) {
                            scope.parent.isAssignmentToolEnabled = scope.collection.isAssignmentToolEnabled;
                        }
                    });
                };

                scope.saveSettings = function(){
                    var type = scope.parent.type;
                    if(type === 'course') {
                        if(scope.parent.isDropboxEnabled !== scope.collection.isDropboxEnabled){
                            scope.toggleDropbox();
                        }
                        if(scope.parent.isAssignmentToolEnabled !== scope.collection.isAssignmentToolEnabled){
                            scope.toggleAssignmentTool();
                        }
                    }
                    var description = scope.collection.description;
                    CollectionService.UpdateCollectionMetadata.update({
                        collectionId : scope.parent.cid,
                        title: scope.parent.title,
                        type: type === 'course' ? 'Courses' : type.charAt(0).toUpperCase() + type.slice(1),
                        description: description,
                        contributor: scope.parent.contributor,
                        lmsCourseId: scope.parent.lmsCourseId
                    }, function(){
                        scope.parent.description = description;
                        scope.settingsApplied = true;
                        scope.settingsChanged = false;
                    });
                };

                scope.closeSettings = function(){
                    if(scope.parent.description) {
                        scope.collection.description = scope.parent.description.length > 255 ? scope.parent.description.substring(0, 255) : scope.parent.description;
                    } else {
                        scope.collection.description = "";
                    }
                    scope.collection.isDropboxEnabled = scope.parent.isDropboxEnabled;
                    scope.collection.isAssignmentToolEnabled = scope.parent.isAssignmentToolEnabled;
                    scope.setSettingsChanged();
                };

                scope.setSettingsChanged = function(){
                    if(scope.parent){
                        if(scope.collection.isAssignmentToolEnabled !== scope.parent.isAssignmentToolEnabled || scope.collection.isDropboxEnabled !== scope.parent.isDropboxEnabled) {
                            scope.settingsApplied = false;
                            scope.settingsChanged = true;
                        }
                    }
                };

                // Make the cancel settings modal accessible
                $("#cancelSettingsModal").on('shown.bs.modal', function () {
                    modalFocus('#cancelSettingsYesBtn', '#cancelSettingsNoBtn');
                });

                var modalFocus = function(first, last){
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };
            }
        }

    }]);
